import LoadingAnimation from "@Atom/LoadingAnimation";
import CandidateContractLayout from "@Organism/Additional/CandidateContract";
import AsyncErrorBoundary from "@Organism/Utils/AsyncErrorBoundary";
import { getContractApproval } from "@Services/contract/contract";
import { Suspense, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Await, defer, useLoaderData, useParams } from "react-router-dom";
import Styles from "./style.module.scss";
import moment from "moment";

import ModalWrapper from "@Atom/ModalWrapper";
import FraudAlertModal from "@Molecule/_modal/FraudAlertModal";
import SendingModal from "@Molecule/_modal/SendingModal";
import { sendFraudReport } from "@Services/officer/fraudReport";

export async function loader({ params }) {
  const hash = params.hash;

  const getContractData = await getContractApproval(hash);

  return defer({
    contractData: getContractData,
  });
}

export default function CandidateContract() {
  const { contractData } = useLoaderData();
  const { hash } = useParams();

  // console.log(hash, "test");

  const [fraudAlertModal, setFraudAlertModal] = useState(true);
  const [scamWarningSession, setScamWarningSession] = useState(false);
  const [files, setfiles] = useState(null);
  const [desc, setDesc] = useState("");
  const [success, setSuccess] = useState(false);

  const handleBackFraud = () => {
    setFraudAlertModal();
    if (scamWarningSession) {
      const today = moment().format("YYYY-MM-DD");
      localStorage?.setItem(`fraudAlertModal_contract_${hash}`, today);
    }
  };

  // response?.candidate?.id

  const [loadingFraud, setLoadingFraud] = useState(false);
  const [error, setError] = useState("");

  const handleSubmitFraud = async (e, id) => {
    try {
      e.preventDefault();
      setLoadingFraud(true);
      const formData = new FormData();

      formData.append("candidateID", id);
      formData.append("remark", desc || "");
      formData.append("file", files || "");

      await sendFraudReport(formData);

      setLoadingFraud(false);
      setFraudAlertModal(false);
      if (scamWarningSession) {
        const today = moment().format("YYYY-MM-DD");
        localStorage?.setItem(`fraudAlertModal_contract_${hash}`, today);
      }
      setSuccess(true);
      setError("");
    } catch (err) {
      setSuccess(false);
      console.log(err);
      setLoadingFraud(false);
      setError(err?.response?.data?.error || err?.response?.data?.message);
    }
  };

  useEffect(() => {
    const savedDate = localStorage.getItem(`fraudAlertModal_contract_${hash}`);
    const today = moment().format("YYYY-MM-DD"); // Format tanggal hari ini
    if (savedDate === today) {
      setFraudAlertModal(false); // Jangan tampilkan modal jika tanggal tersimpan adalah hari ini
    }
  }, [hash]);

  return (
    <div className={Styles.container}>
      <Helmet>
        <title>Kerja 365 | Candidate Contract</title>
      </Helmet>

      <Suspense
        fallback={
          <div
            style={{
              display: "grid",
              placeItems: "center",
              height: "100vh",
              width: "100%",
            }}
          >
            <div style={{ width: "250px", aspectRatio: 1 }}>
              <LoadingAnimation />
            </div>
          </div>
        }
      >
        <Await
          resolve={contractData}
          errorElement={
            <div style={{ height: "calc(100vh - 220px)" }}>
              <AsyncErrorBoundary />
            </div>
          }
        >
          {(contractData) => (
            <Suspense
              fallback={
                <div
                  style={{
                    display: "grid",
                    placeItems: "center",
                    height: "100vh",
                    width: "100%",
                  }}
                >
                  <div style={{ width: "250px", aspectRatio: 1 }}>
                    <LoadingAnimation />
                  </div>
                </div>
              }
            >
              <Await
                resolve={contractData}
                errorElement={
                  <div style={{ height: "calc(100vh - 220px)" }}>
                    <AsyncErrorBoundary />
                  </div>
                }
              >
                {(contractData) => (
                  <div
                    style={{
                      overflow: "auto",
                      maxHeight: "100vh",
                    }}
                  >
                    <CandidateContractLayout data={contractData} />
                    {fraudAlertModal && (
                      <ModalWrapper
                        show={fraudAlertModal}
                        handleClose={() => {}}
                      >
                        <FraudAlertModal
                          isChecked={scamWarningSession}
                          setIsChecked={setScamWarningSession}
                          handleBack={handleBackFraud}
                          files={files}
                          setfiles={setfiles}
                          desc={desc}
                          setDesc={setDesc}
                          handleClose={() => {
                            setFraudAlertModal(false);
                          }}
                          handleSubmit={(e) =>
                            handleSubmitFraud(
                              e,
                              contractData?.response?.candidate?.id
                            )
                          }
                          error={error}
                          loadingFraud={loadingFraud}
                        />
                      </ModalWrapper>
                    )}

                    {success && (
                      <SendingModal
                        handleDone={() => {
                          setSuccess(false);
                        }}
                        isDone={success}
                        show={success}
                        setShow={setSuccess}
                      />
                    )}
                  </div>
                )}
              </Await>
            </Suspense>
          )}
        </Await>
      </Suspense>
    </div>
  );
}
